import { Component} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Location } from "@angular/common";

@Component({
    selector: "app-advanced-overview",
    templateUrl: "./advanced-overview.component.html",
    styleUrls: ["./advanced-overview.component.scss"],
})
export class AdvancedOverviewComponent {
    constructor(router: Router, private location: Location) {
        router.events.subscribe((s) => {
            if (s instanceof NavigationEnd) {
                const tree = router.parseUrl(router.url);
                if (tree.fragment) {
                    const element = document.querySelector("#" + tree.fragment);
                    if (element) {
                        element.scrollIntoView();
                    }
                }
            }
        });
    }

    loadBack() {
        this.location.back();
    }
}
